import React, { useEffect, useState } from "react";
import axios from "axios";
import { Api_Caller } from "../../utils/Api";
import { useSelector } from "react-redux";
import SummaryCards from "./components/SummaryCards";
import AttendanceTable from "./components/AttendanceTable";
import RecentVisits from "./components/RecentVisits";
import "leaflet/dist/leaflet.css";

function Dashboard() {
  const auth = useSelector((state) => state.auth || {});

  const [summary, setSummary] = useState(null);
  const [attendance, setAttendance] = useState([]);
  const [recentVisits, setRecentVisits] = useState([]);
  const [loading, setLoading] = useState(false);
 
  const getDashboardSummary = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ALL}/${Api_Caller.summary}`,
        {
          headers: {
            Authorization: `Bearer ${auth.accessToken}`,
          },
        },
      );

      setSummary(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAttendance = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ALL}/${Api_Caller.attendance}`,
        {
          headers: {
            Authorization: `Bearer ${auth.accessToken}`,
          },
        },
      );

      setAttendance(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getRecentVisits = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ALL}/${Api_Caller.visits}`,
        {
          headers: {
            Authorization: `Bearer ${auth.accessToken}`,
          },
        },
      );

      setRecentVisits(response.data.data.content);
    } catch (error) {
      console.log(error);
    }
  };

 

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    setLoading(true);
    await Promise.all([
      getDashboardSummary(),
      getAttendance(),
      getRecentVisits(),
    ]);
    setLoading(false);
  };

  return (
   <>
      <SummaryCards summary={summary} />
      <AttendanceTable attendance={attendance} />
      <RecentVisits recentVisits={recentVisits} />
      </>
    
  );
}

export default Dashboard;
